// Helper to get dietary nutrient metadata from store
export function getDietaryNutrientMeta(dvKey, store) {
  if (!store || !store.dietaryNutrientsMap) return null;
  return store.dietaryNutrientsMap[dvKey] || null;
}

export function getDietaryLabel(dvKey, store) {
  const meta = getDietaryNutrientMeta(dvKey, store);
  return meta?.label || dvKey;
}

export function getDietaryUnit(dvKey, store) {
  const meta = getDietaryNutrientMeta(dvKey, store);
  return meta?.unit || "mg";
}

export function getDietaryIndentLevel(dvKey, store) {
  const meta = getDietaryNutrientMeta(dvKey, store);
  return meta?.indent_level || 0;
}

// Checks if a line represents added sugars (works for both DV lines and dietary lines)
export function isAddedSugars(line) {
  const key = line.dv_key || "";
  return key === "added_sugar";
}

// Internal helper - only used by getIndentClass in this file
function isSubNutrient(line, subNutrients) {
  const key = line.dv_key || "";
  return subNutrients.includes(key);
}

// Get indent class for DV lines (uses dynamic subNutrients list from store)
export function getIndentClass(line, subNutrients) {
  if (isAddedSugars(line)) return "SupplementFacts-Indent-Double";
  if (isSubNutrient(line, subNutrients)) return "SupplementFacts-Indent";
  return "";
}

// Get indent class for dietary lines (uses backend metadata)
export function getDietaryIndentClass(line, store) {
  const indentLevel = getDietaryIndentLevel(line.dv_key, store);
  if (indentLevel === 2) return "SupplementFacts-Indent-Double";
  if (indentLevel === 1) return "SupplementFacts-Indent";
  return "";
}

// Get row class - works for both DV and dietary lines
export function getRowClass(line) {
  if (isAddedSugars(line)) return "SupplementFacts-Row-AddedSugars";
  return "";
}

// Alias for backward compatibility
export const getDietaryRowClass = getRowClass;

// Alias for backward compatibility - use isAddedSugars instead
export const isDietaryAddedSugars = isAddedSugars;
